module.exports = __webpack_public_path__ + "img/icon-electrician.3ef833d5.png";